export default __webpack_public_path__ + "static/media/label.fce0776f.svg";